import { isFavourite } from 'helpers/Project'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useEffect } from 'react'
import TagManager from '@sooro-io/react-gtm-module'
import ProjectHeader from './ProjectHeader'

const ProjectHeaderContainer = ({
  authentication,
  currentLocale,
  dispatch,
  favourite,
  project,
  projectComplete,
}) => {
  useEffect(() => {
    const userID = authentication.user?.profile?.user

    TagManager.dataLayer({
      dataLayer: {
        event: 'identify_user',
        userID: userID ? `'${userID}'` : null,
        loggedIn: !!userID,
      },
    })
  }, [authentication.user])

  return (
    <ProjectHeader
      authentication={authentication}
      dispatch={dispatch}
      favourite={favourite}
      hardware={project.hardware}
      imageUrl={project.heroImage}
      included={project.included}
      locale={currentLocale}
      projectComplete={projectComplete}
      projectId={project.id}
      software={project.software}
      title={project.title}
      loading={project.loading}
    />
  )
}

ProjectHeaderContainer.propTypes = {
  authentication: PropTypes.object,
  currentLocale: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  favourite: PropTypes.bool.isRequired,
  project: PropTypes.object.isRequired,
  projectComplete: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  const { project, currentLocale } = state.project
  const { authentication, dispatch } = state
  return {
    authentication,
    currentLocale,
    dispatch,
    favourite: isFavourite(state.favourites, state.project.project),
    project,
  }
}

export default connect(mapStateToProps)(ProjectHeaderContainer)
